import React, { useState } from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import AboutSection from '../components/landing/AboutSection';
import ProductsSection from '../components/landing/ProductsSection';
import VideoSection from '../components/landing/VideoSection';
import ClientsSection from '../components/landing/ClientsSection';
import UseCasesSection from '../components/landing/UseCasesSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import FAQSection from '../components/landing/FAQSection';
import PressSection from '../components/landing/PressSection';
import CTASection from '../components/landing/CTASection';
import ContactForm from '../components/landing/ContactForm';
import Footer from '../components/landing/Footer';
import { COLORS, CONTACT } from '../data/siteData';
import { X } from 'lucide-react';

const LandingPage = () => {
  const [showContactForm, setShowContactForm] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: COLORS.background }}>
      <Header 
        onDemoClick={() => setShowContactForm(true)} 
        scrollToSection={scrollToSection}
        isTransparent={true}
      />
      <main>
        <HeroSection 
          onDemoClick={() => setShowContactForm(true)}
          onInstallationsClick={() => scrollToSection('installations')}
        />
        <AboutSection />
        <ProductsSection />
        <VideoSection />
        <ClientsSection />
        <UseCasesSection />
        <FeaturesSection onContactClick={() => scrollToSection('contact')} />
        <FAQSection />
        <PressSection />
        <CTASection onContactClick={() => scrollToSection('contact')} />
        <ContactForm />
      </main>
      <Footer />
      
      {/* Demo Request Modal */}
      {showContactForm && (
        <div 
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
          onClick={() => setShowContactForm(false)}
        >
          <div 
            className="bg-white rounded-lg max-w-lg w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold" style={{ color: COLORS.dark }}>
                  {CONTACT.title}
                </h3>
                <button 
                  onClick={() => setShowContactForm(false)}
                  className="hover:opacity-70 transition-opacity"
                  style={{ color: COLORS.gray }}
                  data-testid="modal-close-btn"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <ContactForm isModal onSuccess={() => setShowContactForm(false)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
